module.exports = __webpack_public_path__ + "media/images/arrow-down-a2ad254e1f52c62a9d11c036443e7cc6.png";